(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["td-countdown-timer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-discount-timer')) {
    class TDDiscountTimer extends HTMLElement {
      constructor() {
        super();
        this.endDate = new Date(this.dataset.countdownDate).getTime();
        this.interval = null;
      }
      connectedCallback() {
        this.setupEventListeners();
        setTimeout(() => {
          this.countdownElement = this.querySelector('.td-countdown-timer__countdown');
          this.valueElements = this.querySelectorAll('.td-countdown-timer__value');
          if (!isNaN(this.endDate)) {
            const timerFunction = () => {
              const currentDate = new Date().getTime();
              const difference = this.endDate - currentDate;
              if (difference <= 0) {
                clearInterval(timerUpdater);
                this.interval = null;
                this.remove();
                return;
              }
              if (this.countdownElement) {
                this.countdownElement.style.display = null;
              }

              const days = Math.floor(difference / (1000 * 60 * 60 * 24));
              const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
              const seconds = Math.floor((difference % (1000 * 60)) / 1000);

              const numberFormatter = (number) => {
                if (number < 0) {
                  return '00';
                } else if (number < 10) {
                  return '0' + number;
                }
                return number;
              };
              if (this.valueElements && this.valueElements.length === 4) {
                this.valueElements[0].innerText = numberFormatter(days);
                this.valueElements[1].innerText = numberFormatter(hours);
                this.valueElements[2].innerText = numberFormatter(minutes);
                this.valueElements[3].innerText = numberFormatter(seconds);
              }
            };
            const timerUpdater = setInterval(timerFunction, 1000);
            this.interval = timerUpdater;
            timerFunction(); // Run immediately to avoid delay
          } else {
            this.remove();
          }
        }, 0);
      }
      disconnectedCallback() {
        if (this.interval) {
          clearInterval(this.interval);
        }
      }
      setupEventListeners() {
        // Placeholder for any future event listeners
      }
    }
    customElements.define('td-discount-timer', TDDiscountTimer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-kuya-main-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-kuya-main-product')) {
    class TdKuyaMainProduct extends HTMLElement {
      connectedCallback() {
        this.updateStickyOffset();
        this.handleResize = this.updateStickyOffset.bind(this);
        window.addEventListener('resize', this.handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
      }

      updateStickyOffset() {
        this.style.setProperty('--offsetTop', `${this.offsetTop}px`);
      }
    }

    customElements.define('td-kuya-main-product', TdKuyaMainProduct);
  }

  if (!customElements.get('td-scroll-to')) {
    class TdScrollTo extends HTMLElement {
      connectedCallback() {
        this.handleClick = this.handleClick.bind(this);
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick(event) {
        event.preventDefault();
        this.scrollToTarget();
      }

      scrollToTarget() {
        const targetSelector = this.getAttribute('target');
        if (!targetSelector) return;

        const offset = parseInt(this.getAttribute('offset'), 10) || 0;
        const selectors = targetSelector.split(',').map((selector) => selector.trim());

        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          if (targetElement) {
            const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });
            return;
          }
        }
      }
    }

    customElements.define('td-scroll-to', TdScrollTo);
  }

  } catch(e) { console.error(e); }
})();
})();
